// --------------------------------------------------------------
// Created On: 2025-06-11
// Author: Dimitra Weinstein
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";

// Button that downloads a report in CSV format.
export default function ReportDownloadButton(props: Props): Component {
  return (
    <button data-test="report-download-button" className="btn btn-primary float-end" onClick={props.onDownloadCsv}>
      {props.children}
    </button>
  );
}

interface Props {
  children?: string;
  onDownloadCsv: () => void;
}
